/* eslint-disable no-underscore-dangle */
function useConfig(mfName) {
    var configs = window.__mf.configs;
    return [configs[mfName]];
}
export default useConfig;
